import { Timestamp } from "firebase/firestore";
import { EventPrice, PersonCategory } from "../types";

// like Partial<>, but child objects are Partial as well
export type Subset<K> = {
  [attr in keyof K]?: K[attr] extends object
    ? Subset<K[attr]>
    : K[attr] extends object | null
      ? Subset<K[attr]> | null
      : K[attr] extends object | null | undefined
        ? Subset<K[attr]> | null | undefined
        : K[attr];
};

export const TimestampMaxYear = 9999;
export const TimestampMax = Timestamp.fromDate(
  new Date(TimestampMaxYear.toString())
);

export const eventPriceSort = (a: EventPrice, b: EventPrice) => {
  if (a.available_until) {
    if (b.available_until) {
      return a.available_until.seconds - b.available_until.seconds;
    }
    return -1;
  } else if (b.available_until) {
    return 1;
  }

  return b.full_price - a.full_price;
};

export const categorySort = (a: PersonCategory, b: PersonCategory) => {
  const fieldCmp = (field: keyof typeof a) => {
    if (a[field] && !b[field]) {
      return -1;
    }
    if (!a[field] && b[field]) {
      return 1;
    }
    return 0;
  };
  const fields: (keyof typeof a)[] = [
    "isStaff",
    "freeEntry",
    "concessionRate",
    "nonParticipant",
    "restricted",
  ];
  for (const field of fields) {
    const cmp = fieldCmp(field);
    if (cmp !== 0) {
      return -cmp;
    }
  }
  return (a.name || "").localeCompare(b.name || "");
};

type DOOR_SCANNER_EVENT_COMMAND = {
  command: "select_event";
  collection: "class-nights" | "events";
  id: string;
  when?: Timestamp;
};

export type DOOR_SCANNER_COMMAND =
  | {
      command?: "scanner" | "form" | "auto" | "";
      target?: string;
      when?: Timestamp;
    }
  | DOOR_SCANNER_EVENT_COMMAND;

type COMMANDS_PLAYLIST =
  | "currently_playing"
  | "reload_playlist"
  | "clear_playlist";
type COMMANDS_STAGE_DISPLAY =
  | "show_playlist"
  | "hide_playlist"
  | "show_curriculum"
  | "hide_curriculum";

export type STAGE_COMMAND = {
  command?: COMMANDS_PLAYLIST | COMMANDS_STAGE_DISPLAY | "";
  when?: Timestamp;
  from?: string;
};
